import React from "react";
import {
  Timer,
  UserPlus,
  PackageMinus,
  UserX,
} from "lucide-react";
import { DashboardKpiItem } from "../components/Kpi/types";

/**
 * Sales Key Operational Insights
 * - `label`: confirmed KPI heading
 * - `helperLabel`: descriptive meaning shown at bottom of card
 * Layout: 1 row × 4 cards
 */
export const getSalesOperationalInsights = (): DashboardKpiItem[] => [
  {
    id: "avg_dispatch_lead_time",
    label: "Avg Dispatch Lead Time",
    value: "3.2 days",
    helperLabel: "Average time from packing complete to dispatch",
    icon: React.createElement(Timer, { size: 16 }),
    accentColor: "#2563eb",
    accentBg: "#eff6ff",
  },
  {
    id: "new_customer_added",
    label: "New Customer Added",
    value: 18,
    helperLabel: "New customers created in the selected period",
    icon: React.createElement(UserPlus, { size: 16 }),
    accentColor: "#0f9f6e",
    accentBg: "#ecfdf5",
  },
  {
    id: "low_stock_items",
    label: "Low Stock Items",
    value: 19,
    helperLabel: "SKUs currently below reorder threshold",
    icon: React.createElement(PackageMinus, { size: 16 }),
    accentColor: "#e67e22",
    accentBg: "#fff7ed",
  },
  {
    id: "customer_inactive_over_1_year",
    label: "Customer Inactive Over 1 Year",
    value: 27,
    helperLabel: "Customers with no order activity for more than 1 year",
    icon: React.createElement(UserX, { size: 16 }),
    accentColor: "#d2363a",
    accentBg: "#fff1f1",
  },
];

export interface OperationalInsightItem {
  id: string;
  label: string;
  value: number | string;
  helperLabel: string;
}

export const mergeSalesOperationalInsights = (
  apiItems?: OperationalInsightItem[],
): DashboardKpiItem[] => {
  const apiItemsById = new Map((apiItems || []).map((item) => [item.id, item]));

  return getSalesOperationalInsights().map((item) => {
    const apiItem = apiItemsById.get(item.id);
    if (!apiItem) return item;

    return {
      ...item,
      label: apiItem.label || item.label,
      value: apiItem.value ?? item.value,
      helperLabel: apiItem.helperLabel || item.helperLabel,
    };
  });
};
